import styled from 'styled-components';

import { StyledMainContentOuter as MainContentOuter } from './main-content/main-content.styles';

export const StyledHeaderText = styled.p`
  font-size: 2.4rem;
`;

export const StyledMainContentOuter = styled(MainContentOuter)`
  margin-bottom: 0;
`;
